































































































































































































































































































































import { renewList, renewListExportApi, renewListData } from "@/api/renewal";
import {
  searchStudent,
  getSelectCourseList,
  staffList,
} from "@/api/globalSearch";
import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import pushView from "../../renewalFrame/pushView.vue";
import remindeView from "../../renewalFrame/remindeView.vue";
import { dateFormat } from "@/utils/timeFormat";
import { mixin } from "@/mixin/tabPageInfoMixin";
import { exportLoop } from "@/utils/export";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
@Component({
  name: "renewalList",
  components: {
    pushView,
    remindeView,
    commonStaffPullDown,
  },
})
export default class extends Mixins(mixin) {
  searchInfo: any = {
    course_type: -1,
    follow_staff_ids: [],
    edu_teacher_ids: [],
    relation_teacher_ids: [],
  };
  studentList = []; // 学员列表
  courseList = []; // 购买课程
  page: number = 1;
  pageSize: number = 10;
  tableData: any[] = [];
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  multipleSelection: [] = [];
  chooseList: [] = [];
  earlyData: any = {};
  pushViewbtn = false;
  remindViewbtn = false;
  staffList = {
    followStaff: [],
    eduTeacher: [],
    relationTeacher: [],
  };
  created() {
    // let cache = PageModule.pageInfo.renewalList;
    // if (cache.pagec) {
    //   this.page = cache.pagec;
    //   this.getList({
    //     page: cache.pagec,
    //     page_size: this.pageSize,
    //   });
    // } else {
    //   this.getList({
    //     page: 1,
    //     page_size: this.pageSize,
    //   });
    // }
    this.mixinGetPageInfo("renewalList");
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
    this.handleSearchStudentList("");
    this.handleSearchCourseList("");
  }
  handleSearchStaff(type: string, value: string) {
    if (type === "followStaff") {
      staffList({
        page: 1,
        page_size: 100,
        status: 1,
        key_word: value,
        job_ids: [3],
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.staffList.followStaff = res.data.list;
        }
      });
    }
    if (type === "eduTeacher") {
      staffList({
        page: 1,
        page_size: 100,
        status: 1,
        key_word: value,
        job_ids: [2],
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.staffList.eduTeacher = res.data.list;
        }
      });
    }
    if (type === "relationTeacher") {
      staffList({
        page: 1,
        page_size: 100,
        status: 1,
        key_word: value,
        job_ids: [1],
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.staffList.relationTeacher = res.data.list;
        }
      });
    }
  }
  handleSearchStudentList(v: any) {
    searchStudent({
      page: 1,
      page_size: 1000,
      key_word: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.studentList = res.data.list;
      }
    });
  }
  // 过滤可选的项
  handleSelect(evt: any) {
    return evt.mobile;
  }
  handleSearchCourseList(v: any) {
    getSelectCourseList({
      page: 1,
      page_size: 1000,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.courseList = res.data.list;
      }
    });
  }
  goStudentDetail(sid: any) {
    this.mixinSavePageInfo("renewalList");
    this.$router.push({
      name: "studyDetails",
      query: {
        id: sid,
      },
    });
  }
  openPushView() {
    if (this.chooseList.length == 0) {
      this.$message({
        type: "warning",
        message: "请选择学员",
      });
      return;
    }
    this.multipleSelection = this.chooseList;
    this.pushViewbtn = true;
  }
  openRemindView() {
    this.remindViewbtn = true;
  }
  getdate(a: any, b: any) {
    return dateFormat(a, b);
  }
  closePushView(e: any) {
    this.pushViewbtn = false;
    if (e == "push") {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    }
  }
  closeRemindView(e: any) {
    this.remindViewbtn = false;
    if (e == "keep") {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    }
  }
  // searchData(e: any) {
  //   this.searchInfo[e.dataName] = e.id;
  //   this.getList({
  //     page: 1,
  //     page_size: this.pageSize,
  //   });
  // }
  handleSearchCourse() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleSelectionChange(arr: []) {
    this.chooseList = arr;
  }
  openRenew(e: any) {
    if (e.course.sales_status == 2) {
      this.$message({
        type: "error",
        message: "课程已关闭购买",
      });
      return;
    }
    this.mixinSavePageInfo("renewalList");
    this.$router.push({
      name: "buyCourseConfirm",
      query: { id: e.student_id, course_id: e.course_id },
    });
  }
  renewremind(e: any) {
    this.multipleSelection = [e] as any;
    this.pushViewbtn = true;
  }
  getList(params: { page: number; page_size: number }) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.course_type >= 0) {
      option.course_type = this.searchInfo.course_type;
    }
    if (this.searchInfo.course_id >= 0) {
      option.course_id = this.searchInfo.course_id;
    }
    if (this.searchInfo.student_id >= 0) {
      option.student_id = this.searchInfo.student_id;
    }
    if (this.searchInfo.sort_field) {
      option.sort_field = this.searchInfo.sort_field;
    }
    if (this.searchInfo.sort_type) {
      option.sort_type = this.searchInfo.sort_type;
    }
    if (this.searchInfo.follow_staff_ids) {
      option.follow_staff_ids = this.searchInfo.follow_staff_ids;
    }
    if (this.searchInfo.edu_teacher_ids) {
      option.edu_teacher_ids = this.searchInfo.edu_teacher_ids;
    }
    if (this.searchInfo.relation_teacher_ids) {
      option.relation_teacher_ids = this.searchInfo.relation_teacher_ids;
    }
    renewList(option).then((res: any) => {
      if (res.error_code === 0) {
        this.earlyData = res.data.config;
        // 为每颗树节点以及树的子节点做唯一标识 1-1,1-2,2-1 的形式
        res.data.renew.list.forEach((item: any, index: any) => {
          item.index = String(index + 1);
          if (item.list.length > 0) {
            // 兼容推送接口，做 student 的数据缓存
            item.student = {
              name: item.name,
            };
            // 兼容推送接口，做 student 的数据缓存
            item.list.forEach((it: any, ind: any) => {
              it.index = String(index + 1) + "-" + String(ind + 1);
              it.student = {
                name: item.name,
              };
            });
            // 将子列表的第一项数据拿到外层展示，然后将子列表的第一项去除
            if (item.list && item.list.length > 0) {
              item.exceed_number = item.list[0].exceed_number;
              item.course_id = item.list[0].course_id;
              item.account_id = item.list[0].account_id;
              item.course = item.list[0].course;
              item.usable_number = item.list[0].usable_number;
              item.staff = item.list[0].staff;
              item.teacher = item.list[0].teacher;
              item.last_remind_time = item.list[0].last_remind_time;
              item.list.shift();
            }
          }
        });
        this.tableData = res.data.renew.list;
        this.page = params.page;
        this.total = res.data.renew.total;
      }
    });
  }
  handleSortChange(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }

  handleExport() {
    const option: renewListData = {
      page: 1,
      page_size: 10,
    };
    if (this.searchInfo.course_type >= 0) {
      option.course_type = this.searchInfo.course_type;
    }
    if (this.searchInfo.course_id >= 0) {
      option.course_id = this.searchInfo.course_id;
    }
    if (this.searchInfo.student_id >= 0) {
      option.student_id = this.searchInfo.student_id;
    }
    renewListExportApi(option).then((res: any) => {
      if (res.error_code === 0) {
        exportLoop(res.data.task_id);
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
    this.mixinSavePageInfo("renewalList");
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
    this.mixinSavePageInfo("renewalList");
  }
}
